import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

// Centered mobile device frame for the whole app
export function MobileFrame({ children, nav }) {
  const { user } = useAuth();
  const sdqu = user?.school === "sdqu";
  return (
    <div className={`min-h-screen app-bg flex justify-center ${sdqu ? "theme-sdqu" : ""}`}>
      <div className={`relative w-full md:max-w-md ${sdqu ? "bg-[#EAF3FC]" : "bg-[#F9FBE7]"} md:shadow-2xl md:my-4 md:rounded-[2.5rem] md:overflow-hidden min-h-screen md:min-h-[calc(100vh-2rem)] flex flex-col`}>
        <div className={`flex-1 overflow-y-auto no-scrollbar ${nav ? "pb-28" : ""}`}>{children}</div>
        {nav}
      </div>
    </div>
  );
}

export function PageContainer({ children, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`px-5 ${className}`}
    >
      {children}
    </motion.div>
  );
}
